<template>
  <div class="main-container" :style="{height:height+'px'}">
    <router-view></router-view>
  </div>
</template>

<script>
import topAside from './top-aside';

export default {
  data () {
    return {
      height: 0,
      width: 0
    };
  },
  components: {
    topAside
  },
  mounted () {
    let mainH = document.documentElement.clientHeight;
    let mainW = document.documentElement.clientWidth;
    this.height = mainH;
    this.width = mainW - 200;
  }
}
</script>
<style scoped lang="scss">
.main-container {
  width: 100%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/mainContent.vue